import { render, staticRenderFns } from "./SpecialSelectedPost.vue?vue&type=template&id=465ac0cf&scoped=true&"
import script from "./SpecialSelectedPost.vue?vue&type=script&lang=js&"
export * from "./SpecialSelectedPost.vue?vue&type=script&lang=js&"
import style0 from "./SpecialSelectedPost.vue?vue&type=style&index=0&id=465ac0cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465ac0cf",
  null
  
)

export default component.exports